<template>
    <div>
        <div v-if="checked" v-cloak>
            <div v-if="checkErrorMsg">
                <h3 class="text-center">{{ checkErrorMsg }}</h3>
            </div>
            <div v-else>
                <div v-if="!isActive" class="mt-2">
                    <form-not-active :activeFrom="activeFrom" :activeTo="activeTo">

                    </form-not-active>
                </div>
                <div v-else>
                    <div class="loader" v-if="loading"></div>
                    <div v-else>
                        <div v-if="form">
                            <div v-if="!entryId">
                                <page-title :showTitle="false" :title="(eventName ? eventName + '/' : '') + (isEnVersion ? form.nameEn : form.name) + '/'  + action"></page-title>
                            </div>

                            <event-description :register-entity-id="form.eventRegisterEntityId"></event-description>

                            <hr />
                            <div class="btn-group" v-if="navigateToEdit">
                                <button type="button" class="btn btn-lg btn-success" @click="onNavogateToEdit">
                                    <i class="fas fa-edit"></i>
                                    {{ $t('buttons.edit.btnText') }}
                                </button>
                            </div>

                            <div class="form-group m-sm-1 m-md-4" v-if="form" v-html="form.header"> </div>

                            <div class="text-left m-0" v-if="!details && form.formTypeId === formTypes.RequestToParticipate">
                                <button type="button" class="btn btn-sm btn-info" @click.stop="loadProfileData">
                                    <i class="fas fa-cloud-download-alt"></i>
                                    {{ $t('buttons.loadProfileData.btnText') }}
                                </button>
                                <div class="alert alert-warning m-0 py-1" role="alert">
                                    Актуализираните тук данни се отнасят само за заявката и няма да бъдат актуализирани в профила Ви. Ако искате да актуализирате данните трябва да го направите в профила си <router-link type="button" to="/account" class="btn btn-link btn-warning m-0 btn-sm" target="_blank">тук </router-link>
                                </div>
                            </div>

                            <div v-if="participantsLoaded">
                                <div v-for="(panel, index) in form.panels" :key="index">
                                    <panel v-if="!panel.isEvaluationPanel"
                                           :panel="panel"
                                           :details="details"
                                           :allowAnonymous="form.allowAnonymous"
                                           :profile-data="profileData"
                                           :is-new="isNew">
                                    </panel>
                                </div>
                            </div>

                            <div class="text-center mt-2" v-if="!details">
                                <div v-if="form.formTypeId === formTypes.RequestToParticipate" class="alert alert-warning m-0 py-1" role="alert">
                                    Заявката ще бъда подадена с въведените в тази форма данни
                                </div>

                                <div class="btn-group">
                                    <button type="button" class="btn btn-lg btn-primary" @click="onSubmit">
                                        <i class="fas fa-save"></i>
                                        {{ $t('buttons.save.btnText') }}
                                    </button>
                                </div>
                            </div>

                            <div class="form-group m-sm-1 m-md-4" v-if="form" v-html="form.footer"> </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <h3 class="text-center">{{ checkErrorMsg }}</h3>
        </div>
    </div>
</template>

<script>
    import Panel from '@/components/dynamic/Panel';
    import PageTitle from '@/components/common/PageTitle';
    import { DynamicRegisterModel, EditorForms, EditorPanel } from '@/models/models'
    import { ComponentType, FormType } from '@/models/enums';
    import FormNotActive from './FormNotActive';
    import formSurveyService from '@/services/formSurvey.service';
    import personService from '@/services/person.service';
    import { mapGetters } from 'vuex';
    import EventDescription from '@/views/registers/dynamic/forms/EventDescription'

    export default {
        inject: ['$validator'],
        props: {
            formToRegisterEntityId: {
                type: [Number, String],
                required: true
            },
            entryId: {
                type: [Number, String]
            },
            eventName: {
                type: String
            },
            details: {
                type: Boolean,
                default: false
            },
            isCompleting: {
                type: Boolean,
                default: false
            }
        },
        components: {
            EventDescription,
            Panel,
            PageTitle,
            FormNotActive
        },
        data() {
            return {
                form: null,
                checked: false,
                checkErrorMsg: '',
                loading: false,
                files: [],
                people: [],
                addresses: [],
                activeFrom: '',
                activeTo: '',
                isActive: false,
                msg: '',
                navigateToEdit: false,
                navigateData: {},
                action: this.entryId ? this.$t('buttons.edit.btnText') : this.$t('buttons.complete.btnText'),
                participants: [],
                participantsLoaded: false,
                sortMultiplier: 1000,
                formTypes: FormType,
                profileData: null,
                visitorData: '',
            }
        },
        methods: {
            loadEmptyFormStructure() {
                this.loading = true;

                formSurveyService
                    .loadEmptyFormStructure(this.formToRegisterEntityId)
                    .then(response => {
                        this.form = new EditorForms(response.data);
                        this.loading = false;
                        this.getParticipants();
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            getParticipants() {
                this.form.panels.forEach(panel => {
                    panel.sort *= this.sortMultiplier;
                    panel.components.forEach(x => {
                        x.isEvaluationPanel = panel.isEvaluationPanel
                    });
                });

                let evaluationPanels = this.form.panels.filter(panel => panel.isEvaluationPanel);
                if (evaluationPanels.length > 0) {
                    this.$http.get(`/api/DynamicForms/GetEventParticipants/${this.formToRegisterEntityId}`).then(result => {
                        if (result && result.data) {
                            evaluationPanels.forEach(panelTemplate => {
                                let sortIndex = panelTemplate.sort;
                                result.data.forEach(participant => {
                                    let hasPanelWithRegisterEntityToPersonId =
                                        this.form.panels.filter(panel => panel.registerEntityToPersonId === participant.registerEntityToPersonId).length > 0;
                                    if (!hasPanelWithRegisterEntityToPersonId) {
                                        if (!panelTemplate.participationTypeId || (panelTemplate.participationTypeId && participant.participationTypeId === panelTemplate.participationTypeId)) {
                                            let newPanel = new EditorPanel({
                                                label: participant.fullName,
                                                labelEn: participant.fullNameEn,
                                                name: participant.fullName + participant.registerEntityToPersonId + new Date().getMilliseconds(),
                                                nameEn: participant.fullNameEn + participant.registerEntityToPersonId.id * 321 + new Date().getMilliseconds() + 3,
                                                sort: sortIndex++,
                                                components: panelTemplate.components,
                                                registerEntityToPersonId: participant.registerEntityToPersonId,
                                                isEvaluationPanel: false
                                            });
                                            newPanel.isEvaluationPanel = false;
                                            this.form.panels.push(newPanel);
                                        }
                                    }
                                });
                            });

                            this.sortPanelsBySort();
                        }
                        this.participantsLoaded = true;
                    }).catch(error => {
                        // TODO: Show error message
                        this.participantsLoaded = true;
                    });
                } else {
                    this.participantsLoaded = true;
                }
            },
            sortPanelsBySort() {
                this.form.panels.sort((panel1, panel2) => {
                    if (panel1.sort < panel2.sort) {
                        return -1;
                    } else if (panel1.sort > panel2.sort) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            },
            loadFormStructureWithEntities() {
                this.loading = true;
                this.participantsLoaded = true;

                formSurveyService
                    .loadFormStructureWithEntities(this.formToRegisterEntityId, this.entryId)
                    .then(response => {
                        this.form = new EditorForms(response.data);

                        this.form.panels.forEach(panel => {
                            panel.components.forEach(x => {
                                x.isEvaluationPanel = panel.isEvaluationPanel
                            });
                        });
                        // Би трябвало да си идват сортирани от сървъра this.sortPanelsBySort();
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            onSubmit() {
                this.$validator.validateAll().then(async result => {
                    if (result) {
                        await this.addEvaluationPanelsToStructure();

                        let fieldsValues = [];
                        this.form.panels.forEach(panel => {
                            panel.components.forEach(component => {
                                component.fieldValue.registerEntryId = this.entryId;
                                component.fieldValue.registerFieldId = component.id;
                                component.fieldValue.fieldType = component.fieldType;
                                component.fieldValue.numberType = component.numberType;
                                component.fieldValue.label = component.label;
                                component.fieldValue.labelEn = component.labelEn;
                                component.fieldValue.name = component.name;
                                component.fieldValue.nameEn = component.nameEn;
                                component.fieldValue.isMultiDropdown = component.isMultiDropdown;
                                component.fieldValue.isEvaluationPanel = component.isEvaluationPanel;
                                if (component.isMultiDropdown) {
                                    component.fieldValue.intValue = '';
                                }
                                fieldsValues.push(component.fieldValue);
                                if (component.fieldType === ComponentType.FileUpload) {
                                    // TODO: Да се направи както people и addresses!
                                    component.fieldValue.files.forEach(file => {
                                        this.files.push(file);
                                    });
                                }
                            });
                        });


                        const dynamicRegisterModel = new DynamicRegisterModel({
                            fieldValues: fieldsValues,
                            people: this.people,
                            addresses: this.addresses,
                            formToRegisterEntityId: this.formToRegisterEntityId,
                            isNew: this.isNew
                        });

                        this.createOrUpdate(dynamicRegisterModel);
                    } else {
                        this.$vs.notify({
                        title: this.$t('buttons.save.btnText'),
                        text: this.$t('notifications.validationError'),
                        color: 'warning',
                        time: this.notificationDuration,
                    });
                    }
                });
            },
            async addEvaluationPanelsToStructure() {
                let panelsToAdd = this.form.panels.filter(panel => !panel.id);
                if (panelsToAdd && panelsToAdd.length > 0) {
                /*  panelsToAdd.forEach(panel => {
                        const sort = panel.sort / this.sortMultiplier;
                        //const fraction = panel.sort % this.sortMultiplier;
                        panel.sort = Math.floor(sort/!* + fraction*!/);
                    }); */
                    // TODO: Send to server and then get back panels and components id's
                    const objToSend = {
                        formId: this.form.id,
                        panels: panelsToAdd
                    };

                    try {
                        let result = await this.$http.post(`/api/DynamicForms/AddPanelsWithComponentsToForm`, objToSend);
                        if (result && result.data) {
                            result.data.forEach(addedPanel => {
                                let panel = this.form.panels.filter(p => p.uid === addedPanel.uid)[0];
                                if (panel) {
                                    panel.id = addedPanel.id;
                                    if (addedPanel.components) {
                                        addedPanel.components.forEach(addedComponent => {
                                            let component = panel.components.filter(c => c.uid === addedComponent.uid)[0];
                                            if (component) {
                                                component.id = addedComponent.id;
                                            }
                                        })
                                    }
                                }
                            });
                        }
                    } catch (error) {
                        // TODO:
                        console.error(error);
                    }
                }
            },
            createOrUpdate(dynamicRegisterModel) {
                this.navigateToEdit = false;
                this.navigateData = {};
                this.loading = true;

                dynamicRegisterModel.visitorData = this.visitorData;

                this.$http.post('/api/DynamicForms/CreateOrUpdateDynamicFormEntity', dynamicRegisterModel).then(response => {
                    this.$vs.notify({
                        title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                        text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    });

                    /* if (this.isNew) {
                        this.mapIdsToFiles(response.data);
                    } */

                    let formEntityId = '';
                    if (this.isNew) {
                        formEntityId = Number(response.data.FormEntityId);
                    } else {
                        formEntityId = Number(this.entryId);
                    }

                    if (this.files.length > 0) {
                        this.uploadFiles(formEntityId, response.data).then(response => {
                            this.$vs.notify({
                                title: this.$t('notifications.success'),
                                text: this.$t('notifications.successUploadingFiles'),
                                color: 'success',
                                time: this.$store.getters.notificationDuration
                            });

                            this.$emit('saved', formEntityId, true);
                        }).catch(error => {
                            this.$vs.notify({
                                title: this.$t('notifications.error'),
                                text: this.$t('notifications.errorUploadingFiles'),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        })
                    } else {
                        this.$emit('saved', formEntityId, false);
                    }
                }).catch(error => {
                    if (!error.response || !error.response.data) {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                        return;
                    }

                    let checkResult = error.response.data;
                    if (checkResult.alreadyCompleted) {
                        this.navigateToEdit = true;
                        this.navigateData = checkResult;

                        this.$vs.notify({
                            title: 'Already completed',
                            text: 'Already completed',
                            color: 'warning',
                            time: this.$store.getters.notificationDuration
                        });
                    }
                }).then(response => {
                    this.loading = false;
                });
            },
            onNavogateToEdit() {
                if (this.navigateToEdit && this.navigateData) {
                    return this.$router.push(`/forms/entryEdit?id=${this.navigateData.formToRegisterEntityId}&entryId=${this.navigateData.entryId}&name=${this.navigateData.eventName}`);
                }
            },
            uploadFiles(formEntityId, dataToMap) {
                return new Promise((resolve, reject) => {
                    if (this.isNew) {
                        this.files = [];
                        this.register.panels.forEach(panel => {
                            panel.components.forEach(component => {
                                if (
                                    component.fieldType === ComponentType.FileUpload
                                ) {
                                    component.fieldValue.files.forEach(file => {
                                        this.files.push(file);
                                    });
                                }
                            });
                        });

                        if (this.isNew) {
                            this.mapIdsToFiles(dataToMap);
                        }
                    }

                    let formData = new FormData();
                    this.files.forEach(file => {
                        formData.append('files', file.content, file.fileName);
                    });

                    const descriptionsJson = this.getFilesDescriptionsJson();
                    formData.append('descriptionJson', descriptionsJson);

                    this.$http.post('/api/DynamicForms/UploadFiles', formData).then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error);
                    });
                })
            },
            mapIdsToFiles(ids) {
                this.files.forEach(file => {
                    const uid = file.uid;
                    const id = ids.resultList.findIndex(x => x.uid === uid);
                    if (id) {
                        file.formEntityFieldValueId = ids.resultList[id].id;
                    }
                });
            },
            getFilesDescriptionsJson() {
                let descriptions = [];
                this.files.forEach(file => {
                    descriptions.push({
                        fileName: file.fileName,
                        description: file.fileDescription,
                        length: file.content.size,
                        registerEntityFieldValueId: file.registerEntityFieldValueId,
                        formEntityFieldValueId: file.formEntityFieldValueId
                    });
                });

                return JSON.stringify(descriptions);
            },
            checkCompletePermissions() {
                return new Promise((resolve, reject) => {
                    formSurveyService
                        .checkCompletePermissions(this.formToRegisterEntityId)
                        .then(response => {
                            resolve(response.data.checkResult);
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            })

                            reject(error);
                        });
                });
            },
            loadProfileData() {
                this.loading = true;
                personService.getByUserId(this.userId)
                    .then(response => {
                        this.profileData = response.data;
                    })
                    .catch(error => {
                        console.log(error.response);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            getVisitorData() {
                this.$fingerprint.get((components) => {
                    this.visitorData = {
                        fingerprint: this.$fingerprint.x64hash128(components.map((pair) => { return pair.value }).join(), 31),
                        fingerprintData: JSON.stringify(components)
                    }
                });
            }
        },
        async mounted() {
            this.checkErrorMsg = this.$t('activeFormCheck');
            this.getVisitorData();

            if (this.details) {
                this.checkErrorMsg = '';
                this.checked = true;
                this.isActive = true;
            } else {
                try {
                    const checkResult = await this.checkCompletePermissions();
                    this.checkErrorMsg = '';

                    if (checkResult) {
                        this.activeFrom = this.$helpers.convertFromUtcToLocal(checkResult.activeFrom);
                        this.activeTo = this.$helpers.convertFromUtcToLocal(checkResult.activeTo);
                        this.isActive = checkResult.isActive;
                        this.msg = checkResult.msg;

                        if (!checkResult.isAnonymousForm && !checkResult.hasProfile) {
                            this.checkErrorMsg = this.$t('missingProfile')
                        }

                        if (!checkResult.hasPermissions) {
                            this.checkErrorMsg += ` ${this.$t('registers.forms.completionRightsWarning')}`;
                        }

                        this.checked = true
                    } else {
                        this.checkErrorMsg = this.$t('activeFormCheckError');
                        this.checked = false
                    }
                } catch (error) {
                    this.checkErrorMsg = this.$t('activeFormCheckError');
                    this.checked = false
                }
            }

            if (this.isNew) {
                this.loadEmptyFormStructure();
            } else {
                this.loadFormStructureWithEntities();
            }
        },
        computed: {
            ...mapGetters(['isEnVersion', 'userId', 'notificationDuration']),
            isNew() {
                let num = Number(this.entryId);
                return isNaN(num) || num <= 0;
            }
        }
    }
</script>
